import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import parameters from '@atlassian/jira-relay/src/__generated__/ui_jiraCapacityQuery$parameters';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const capacityEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-jira-capacity" */ './src'),
	),
	getPreloadProps: (entryPointRouteParams: EntryPointRouteParams) => {
		const {
			context: { match },
			tenantContext: { cloudId },
		} = entryPointRouteParams;

		const sourceAri = `ari:cloud:jira-software:${cloudId}:board/${match.params.boardId}`;

		// @TODO - https://hello.jira.atlassian.cloud/browse/JPO-35082
		// remove this mockAri when it is not needed anymore
		const mockAri = 'ari:cloud:jira-software:a729796c-2ed4-4307-913a-d82357bb2f9a:board/123';

		return {
			queries: {
				capacityData: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters,
					variables: {
						cloudId,
						id: sourceAri || mockAri,
					},
				},
			},
			entryPoints: {},
			extraProps: {},
		};
	},
});
